
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Header from '../../components/Header'
import EditNoteIcon from '@mui/icons-material/EditNote'
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm'
import ArticleIcon from '@mui/icons-material/Article'
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop'
import MonitorIcon from '@mui/icons-material/Monitor'
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications'
import TitleBar from '../../components/uiParts/TitleBar'
import MenuIcon from '../../components/uiParts/MenuIcon'
import GradeIcon from '@mui/icons-material/Grade'
import WorkHistoryIcon from '@mui/icons-material/WorkHistory'
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd'
import CloudDoneIcon from '@mui/icons-material/CloudDone'
import AlarmAddIcon from '@mui/icons-material/AlarmAdd'
import FolderIcon from '@mui/icons-material/Folder'
import { useAuth } from '../../contexts/AuthContext'

const SystemMastaMenu = () => {
    
    const { authInfo } = useAuth()
    const navigate = useNavigate()

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const facilityCode   = authInfo.facilityCode
    const facilityName   = authInfo.facilityName
    const loginUserId    = authInfo.userId
    const loginUserName  = authInfo.userName
    const lobinAuthority = authInfo.authority
    
	//===============================================
	// イベントハンドラ
	//===============================================
    const handleClick = (url) => {
        navigate(url)
    }
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
        <Header loginInfo="on" backButton="on" backPage="/home" />
            <div className='menu' style={{paddingTop:'2px', paddingLeft:'10px', paddingRight:'10px', paddingBottom:'10px'}}>
                <div>
                    <TitleBar title="システムマスタメニュー" />
                    <MenuIcon header="maintenance Menu" title="ユーザマスタ"  onClick={() => handleClick('/userList')}>
                        <SettingsApplicationsIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="maintenance Menu" title="仲買人マスタ"  onClick={() => handleClick('/traderList')}>
                        <SettingsApplicationsIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="maintenance Menu" title="セリ人マスタ"  onClick={() => handleClick('/bidPersonList')}>
                        <SettingsApplicationsIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <TitleBar title="基幹マスタメニュー" />
                    <MenuIcon header="maintenance Menu" title="基幹荷主マスタ"  onClick={() => handleClick('/originalShipList')}>
                        <SettingsApplicationsIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="maintenance Menu" title="基幹魚種マスタ"  onClick={() => handleClick('/originalFishSpecList')}>
                        <SettingsApplicationsIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                </div>
            </div>
        </>
    )
}
export default SystemMastaMenu

  